import axios from 'axios'
import semver from 'semver'
import forIn from 'lodash/forIn'

export const state = () => ({
  log: null,
  selectionCount: 0,
  update: {
    show: false,
    url: null,
    message: null
  },
  drag: {
    item: null
  }
})

export const mutations = {
  set (state, data) {
    forIn(data, (value, key) => {
      state[key] = value
    })
  },
  setLog (state, log) {
    state.log = log
  },
  update (state, { message, url }) {
    state.update.message = message
    state.update.url = url
    state.update.show = true
  },
  clearUpdateMessage (state) {
    state.update.show = false
  },
  setDragItem (state, item) {
    state.drag.item = item
  }
}

export const actions = {
  async checkForUpdates ({ state, commit }) {
    console.log(process.env.VUE_APP_VERSION)
    // Check for updates in GitHub Releases
    const response = await axios('https://api.github.com/repos/Iconscout/icondrop/releases')
    const latestRelease = response.data[0]
    const currentVersion = semver.coerce(process.env.VUE_APP_VERSION)
    const latestVersion = semver.coerce(latestRelease.tag_name)

    const updateAvailable = semver.lt(currentVersion, latestVersion)

    if (updateAvailable) {
      // commit('update', {
      //   message: latestRelease.name,
      //   url: latestRelease.html_url
      // })
    } else {
      console.log('Already latest update')
    }
  }
}
